(ns client-portal.client.voice-insights.duration.data
  (:require [shared.core.reactive :as re]
            [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.core.data :as core.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [shared.core.components.recharts.util :as recharts.util]
            [client-portal.client.voice-insights.tags.data :as tags.d]
            [shared.core.util :as util]))

(def root-path [:voice-insights :duration])
(def data-path (conj root-path :data))
(def charts-data-path (conj data-path :charts))
(def settings-path (conj root-path :settings))

(re/reg-event-fx
  :vi-duration/initialize re/middleware
  (fn [{:keys [db]}]
    (re/dispatch [:vi-duration/initialize-filters])
    (re/dispatch [:vi-duration/reload])
    (re/dispatch [:voice-insights/reload-core-session-by-time-counts])
    {:db db
     :forward-events {:register :vi-duration-initialization-listener
                      :events #{:concepts/select :locations/select :core/select-crew-type
                                :core/select-timeframe :locations/clear-selected
                                :core/timeframe-date-range-changed}
                      :dispatch-to [:vi-duration/reload]}}))

(re/reg-event-db
  :vi-duration/initialize-filters re/middleware
  (fn [db]
    (core.d/initialize-common-filters db)))

(re/reg-event-db
  :vi-duration/reload re/middleware
  (fn [db]
    (re/dispatch [:voice-insights/reload-core-session-by-time-counts])
    (-> db
        (assoc-in charts-data-path nil))))

(defn transf-duration-sankey-data [d]
  (merge (recharts.util/group-and-format-time-grouping-data
           {:data d
            :count-group-by-key :duration-range})
         {:summary (->> d
                        (filter #(= (:time-grouping %) "summary"))
                        (first))}))

(defn transf-charts-data [d]
  (-> d
      (util/update-when-not-nil :call-duration-range-by-time transf-duration-sankey-data)
      (util/update-when-not-nil :phase-intro-duration-range-by-time transf-duration-sankey-data)
      (util/update-when-not-nil :phase-ordering-duration-range-by-time transf-duration-sankey-data)
      (util/update-when-not-nil :issue-wait-to-ordering-duration-range-by-time transf-duration-sankey-data)
      (util/update-when-not-nil :issue-wait-by-time #(recharts.util/group-and-format-time-grouping-data {:data %}))))

(re/reg-auth0-loader
  :vi-duration/load-charts-data
  charts-data-path
  (fn [db _]
    (let [cur-tags (tags.d/current-tags-list-set db)
          cur-tag-names (tags.d/current-tag-names-list-set db)]
      (when (and (concepts.d/current-concept-id db)
                 (not (util/loading? cur-tag-names))
                 (not-empty cur-tag-names))
        {:method :post
         :url "/api/vi/duration/charts"
         :json-params (assoc (vi.d/base-query-args db {})
                        :data-keys (cond-> ["call-duration-range-by-time"]

                                           (and (contains? cur-tags {:name "phase" :value "intro"})
                                                (contains? cur-tags {:name "phase" :value "ordering"}))
                                           (conj "phase-intro-duration-range-by-time")

                                           (and (contains? cur-tags {:name "issue" :value "wait"})
                                                (contains? cur-tags {:name "phase" :value "ordering"}))
                                           (conj "issue-wait-to-ordering-duration-range-by-time")

                                           (contains? cur-tags {:name "phase" :value "ordering"})
                                           (conj "phase-ordering-duration-range-by-time")

                                           (contains? cur-tags {:name "issue" :value "wait"})
                                           (conj "issue-wait-by-time")

                                           (contains? cur-tag-names "intent-summary")
                                           (conj "intent-durations-by-value")))})))
  :transf #(or (some-> % :body (util/->kebab-case-keywords) (transf-charts-data)) [])
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :vi-duration/charts-data-
  charts-data-path
  :vi-duration/load-charts-data)
